import { Injectable } from "@angular/core";
import { ApiService } from "@edp-services/api.service";

@Injectable({
    providedIn: "root",
})
export class EdpeService {
    constructor(private apiService: ApiService) {}

    public getUserEfficiency(args?) {
        return this.apiService.callServicePostToCollection(`EdpE.User.getUserEfficiency`, args || {});
    }

    public getDashboard() {
        return this.apiService.callServicePostToCollection(`dashboardManagement.getDashboard`, {});
    }

    public getProductServiceCardData(codes: string[]) {
        return this.apiService.callServicePostToCollection(`EnergyEfficiency.ProductsServices.getPsData`, { codes });
    }

    public getEnergyEfficiencyCards(ContractId: string) {
        return this.apiService.callServicePostToCollection("energyEfficiencyManagement.getEnergyEfficiency", { ContractId }, null, false);
    }

    public setMacroChallengeSubscription(event: {}) {
        return this.apiService.callServicePostToCollection(`dashboardManagement.subscribeMacroChallengeEvent`, event);
    }

    public getLocalCampaign() {
        return this.apiService.callServicePostToCollection("EdpE.ParishCampaign.getParishScore", {});
    }

    public getUserAvailableParishList() {
        return this.apiService.callServicePostToCollection("EdpE.ParishCampaign.getUserAvailableParishList", {});
    }

    public getUserParticipation() {
        return this.apiService.callServicePostToCollection("EdpE.ParishCampaign.getUserParticipation", {});
    }

    public insertUserParticipation(contractId) {
        return this.apiService.callServicePostToCollection("EdpE.ParishCampaign.insertUserParticipation", { contractId });
    }

    public shareToEarn(data) {
        const params = !!data.sendTo ? {type: data.type, sendTo: data.sendTo} : {type: data.type, channel: data.channel};
        return this.apiService.callServicePostToCollection("EdpE.ParishCampaign.shareToEarn", params);
    }

    public getMgmCode() {
        return this.apiService.callServicePostToCollection(`memberGetMember.getCode`, {});
    }

    public validateMgmCode(args) {
        return this.apiService.callServicePostToCollection(`memberGetMember.validate`, args);
    }

    public sendShareEmail(args) {
        return this.apiService.callServicePostToCollection(`memberGetMember.sendShare`, args);
    }

    public sendShareSocial(args) {
        return this.apiService.callServicePostToCollection(`memberGetMember.sendShare`, args);
    }

    public updateMgmAlert(args) {
        return this.apiService.callServicePostToCollection(`memberGetMember.updateDateView`, args);
    }

    public getQuizzs() {
        return this.apiService.callServicePostToCollection("partners.getQuizzes", {});
    }

    public getComparatorEfficientHouse(contractId) {
        return this.apiService.callServicePostToCollection(`reading.getEnergyEfficiencyOfTheMonth`, { contractId: Number(contractId) });
    }

    public getComparatorElectricMobility(contractId) {
        return this.apiService.callServicePostToCollection(`energyEfficiencyManagement.getEMobilityComparator`, { contractId });
    }
}
